import {
  IAddUpdatePaiyaGiftPageProps,
  IAddUpdatePaiyaGiftPageState,
} from "interfaces/Index";
import { Container, Row, Col, Form } from "reactstrap";
import React, { useState, useEffect } from "react";
import LoaderComponent from "../../common/Loader/Loader";
import HeadingText from "components/common/HeadingText/HeadingText";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import TextField from "components/common/TextField/TextField";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { normalizePaiyaGiftCreatePayload } from "normalizer/PaiyaGiftNormalizer";
import UploadButtonComponent from "components/common/UploadButton/UploadButtonComponent";
import "./AddUpdatePaiyaGiftPage.scss";
import Toaster from "components/common/Toaster/Toaster";
import {
  PAIYA_GIFT_TOAST_MESSAGE,
  PAIYA_GIFT_TYPES,
  TITLE_PLACEHOLDER,
} from "./PaiyaGiftsTableConstants";
import { acceptableFormats } from "config/constants";
import backarrow from "../../../assets/images/back_arrow.svg";

const AddUpdatePaiyaGiftPage: React.FunctionComponent<
  IAddUpdatePaiyaGiftPageProps
> = (props: IAddUpdatePaiyaGiftPageProps) => {
  const [paiyaGiftState, setPaiyaGiftState] =
    useState<IAddUpdatePaiyaGiftPageState>(props.defaultPaiyaGift);

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const {
    backButtonHandler,
    isLoading,
    uploadImageAndCreatePaiyaGiftAction,
    clearPaiyaGiftDetails,
  } = props;

  useEffect(() => {
    const { isPaiyaGiftCreated, isError } = props;
    if (isPaiyaGiftCreated && !isError) {
      const message = PAIYA_GIFT_TOAST_MESSAGE;
      handleToaster(false, message);
    }
  }, [props.isPaiyaGiftCreated, props.isError]);

  useEffect(() => {
    const { isPaiyaGiftCreated, backButtonHandler } = props;
    if (isPaiyaGiftCreated) {
      clearPaiyaGiftDetails();
      backButtonHandler(true, false);
    }
  }, [props.isPaiyaGiftCreated]);

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleGoBackButton = () => {
    clearPaiyaGiftDetails();
    backButtonHandler(false);
  };

  const handleSubmit = () => {
    const reqPayload = normalizePaiyaGiftCreatePayload(paiyaGiftState);
    uploadImageAndCreatePaiyaGiftAction(
      reqPayload.formData,
      reqPayload.payload
    );
  };

  const handleSearchableSelect = (e: any, fieldId: string) => {
    setPaiyaGiftState({
      ...paiyaGiftState,
      [fieldId]: e,
      value: "",
    });
  };

  const handleChange = (e: any) => {
    const fieldId: string = e.target.id;
    const fieldValue: string = e.target.value;

    setPaiyaGiftState({
      ...paiyaGiftState,
      [fieldId]: fieldValue,
    });
  };

  const handleGiftImageUpload = (payload: any) => {
    setPaiyaGiftState({
      ...paiyaGiftState,
      image: { ...paiyaGiftState.image, ...payload },
    });
  };
  const renderPaiyaGiftForm = () => {
    return (
      <>
        <FormSectionLayout subTitleText="Paiya details">
          <SearchableSelect
            id="type"
            isSearchable={true}
            options={PAIYA_GIFT_TYPES}
            placeholder="Type"
            onChange={(e: any) => {
              handleSearchableSelect(e, "type");
            }}
            label="type"
            selectedValue={paiyaGiftState.type}
          />

          <TextField
            id="title"
            label="title"
            placeholder={TITLE_PLACEHOLDER[paiyaGiftState.type.id]}
            value={paiyaGiftState.title}
            handleChange={handleChange}
          />

          {paiyaGiftState.type.id === "COINS" ? (
            <TextField
              id={"value"}
              placeholder=""
              value={paiyaGiftState.value}
              label={"Value"}
              handleChange={handleChange}
              type={"number"}
            />
          ) : (
            <TextField
              id={"value"}
              placeholder=""
              value={paiyaGiftState.value}
              label={"Product Id"}
              handleChange={handleChange}
              type={"string"}
            />
          )}
        </FormSectionLayout>
        <FormSectionLayout subTitleText="Gift Image">
          <div className="gift-image-upload-container">
            {paiyaGiftState.image &&
            (paiyaGiftState.image! as any).base64StringUrl ? (
              <div className="gift-image-container">
                <img
                  src={(paiyaGiftState.image! as any).base64StringUrl}
                  alt="product"
                />
              </div>
            ) : (
              <img
                src="../../../assets/images/product_placeholder_image.png"
                alt="placeholder"
              />
            )}
            {/* <Can I="create" a="image"> */}
            <UploadButtonComponent
              id="productImage"
              helperText="400*400 - max 200kb"
              buttonText="Upload .png image"
              fileFormat={acceptableFormats.image}
              handleFileChange={handleGiftImageUpload}
            />
            {/* </Can> */}
          </div>
        </FormSectionLayout>
      </>
    );
  };

  function isFormInputValid() {
    let isValid = true;
    if (
      !paiyaGiftState.title.length ||
      !paiyaGiftState.type.value.length ||
      !paiyaGiftState.value
    ) {
      isValid = false;
    }
    return isValid;
  }

  const renderFormButton = () => {
    const isLoading = props.isLoading;
    return (
      <FormSectionLayout subTitleText="">
        <div className="form-row-separator">
          <Row id="addEditButtonRow">
            <Col lg="6">
              {/* {(ability.can("update", "zone") ||
                                    ability.can("create", "zone")) && ( */}
              <ButtonComponent
                buttonClass="large-button btn-primary"
                buttonText={buttonText}
                onClickHandler={handleSubmit}
                isDisable={isLoading || !isFormInputValid()}
              />
              {/* )} */}
            </Col>
          </Row>
        </div>
      </FormSectionLayout>
    );
  };

  const buttonText = "Create New Gift";

  return (
    <div>
      <Container fluid>
        {isLoading && <LoaderComponent />}
        <Toaster
          showToaster={showToaster.isVisible}
          toasterClass={
            showToaster.isError
              ? "toaster toaster-bg-danger"
              : "toaster toaster-bg-success"
          }
        >
          {showToaster.message || ""}
        </Toaster>
        <Row>
          <Col lg="5">
            <div className="back-button">
              <a href="javascript:void(0)" onClick={handleGoBackButton}>
                {" "}
                {/* TO-DO: Convert this to a button in all compoents. */}
                <span>
                  <img src={backarrow} alt="close" />
                </span>{" "}
                Back to Paiya Gifts
              </a>
            </div>
            <HeadingText text={buttonText} isMainHeading={true} />
          </Col>
        </Row>
        <Row className="form-container add-update-zonal-config-page">
          <Col xs="12">
            <Form>
              <div className="form-row-separator">
                {renderPaiyaGiftForm()}
                {renderFormButton()}
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddUpdatePaiyaGiftPage;
